"use client";

import { HttpTypes } from "@medusajs/types";
import { getRegion } from "@/lib/data/regions";
import { setCountryCookie } from "@/lib/util/country";

/**
 * Syncs location from customer metadata into Zustand stores.
 * Call this after login / register when you have the customer object.
 * Returns true if a location was synced, false otherwise.
 */
export async function syncLocationFromCustomer(
  customer: HttpTypes.StoreCustomer | null,
  stores: {
    setRegion: (region: HttpTypes.StoreRegion | null) => void;
    setCountryCode: (code: string | null) => void;
    setHasSelectedRegion: (value: boolean) => void;
    setProvince: (province: string, provinceName: string) => void;
    setMunicipality: (municipality: string) => void;
    setHasSelectedLocation: (value: boolean) => void;
  }
): Promise<boolean> {
  if (!customer) return false;

  const metadata = customer.metadata || {};
  const countryCode = metadata.country_code as string | undefined;
  const province = metadata.province as string | undefined;
  const provinceName = metadata.province_name as string | undefined;
  const municipality = metadata.municipality as string | undefined;

  if (!countryCode || !province) return false;

  const region = await getRegion(countryCode);
  if (!region) return false;

  stores.setRegion(region);
  stores.setCountryCode(countryCode);
  stores.setHasSelectedRegion(true);
  stores.setProvince(province, provinceName || province);
  if (municipality) stores.setMunicipality(municipality);
  stores.setHasSelectedLocation(true);
  setCountryCookie(countryCode);

  return true;
}
